import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15a6fe4e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=15a6fe4e&prod&scoped=true&lang=css"
import style2 from "./index.vue?vue&type=style&index=2&id=15a6fe4e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a6fe4e",
  null
  
)

export default component.exports